// ============================================
// CEV - Calificación Energética de Viviendas
// ============================================

(function () {
  'use strict';

  // --- Tab Switching ---
  document.querySelectorAll('.cev-tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tabId = btn.dataset.tab;
      document.querySelectorAll('.cev-tab-btn').forEach(function (b) {
        b.classList.toggle('active', b.dataset.tab === tabId);
      });
      document.querySelectorAll('.cev-tab-panel').forEach(function (panel) {
        panel.classList.toggle('active', panel.dataset.panel === tabId);
      });
    });
  });

  // --- Groq Proxy ---
  var PROXY_URL = 'https://groq-proxy.francisco-zeising.workers.dev';

  async function callIA(systemInstruction, userText) {
    var response = await fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ systemInstruction: systemInstruction, userText: userText })
    });
    var data = await response.json();
    return data.text || 'Lo siento, no pude generar una respuesta.';
  }

  // --- QA Libre ---
  var qaBtn = document.getElementById('cev-qa-btn');
  if (qaBtn) {
    qaBtn.addEventListener('click', async function () {
      var question = document.getElementById('cev-ia-question').value.trim();
      var resultDiv = document.getElementById('cev-qa-result');
      var loadingDiv = document.getElementById('cev-qa-loading');
      if (!question) return;

      resultDiv.style.display = 'none';
      loadingDiv.style.display = 'block';

      var systemPrompt = 'Eres un consultor experto en Chile sobre la Ley 21.305 de Eficiencia Energética y la Calificación Energética de Viviendas (CEV). Hoy es 2026, la ley está plenamente vigente obligando a inmobiliarias. Responde dudas de usuarios comunes sobre sus derechos al comprar, de forma directa, amable y breve (máximo 2 párrafos). Usa español de Chile coloquial.';

      try {
        var text = await callIA(systemPrompt, question);
        resultDiv.innerHTML = '<p>' + text.replace(/\n/g, '<br>') + '</p>';
      } catch (e) {
        resultDiv.innerHTML = '<p style="color:#ef4444">Error de conexión. Intenta de nuevo.</p>';
      } finally {
        loadingDiv.style.display = 'none';
        resultDiv.style.display = 'block';
      }
    });
  }

  // --- Plan de Mejora por Zona ---
  var mejoraBtn = document.getElementById('cev-mejora-btn');
  if (mejoraBtn) {
    mejoraBtn.addEventListener('click', async function () {
      var clima = document.getElementById('cev-ia-clima').value;
      var resultDiv = document.getElementById('cev-mejora-result');
      var loadingDiv = document.getElementById('cev-mejora-loading');
      if (!clima) { alert('Selecciona tu zona climática primero.'); return; }

      resultDiv.style.display = 'none';
      loadingDiv.style.display = 'block';

      var systemPrompt = 'Eres un arquitecto chileno experto en Eficiencia Energética. El usuario quiere mejorar la Calificación Energética (CEV) de su casa usada para subir de letra y venderla más cara o ahorrar en calefacción. Te dará su zona climática. Genera las 3 inversiones más rentables que debe hacer físicamente a su casa para ESE clima específico. Devuelve HTML usando una lista ordenada <ol class="list-decimal pl-4"> y <li>. Resalta la acción principal en <strong> y explica brevemente por qué mejora la nota CEV.';

      try {
        var html = await callIA(systemPrompt, 'Clima: ' + clima);
        var clean = html.replace(/html|```/g, '');
            resultDiv.innerHTML = '<h4 style="font-weight:700;margin-bottom:0.75rem;color:#92400e">Top 3 Mejoras para ' + clima + ':</h4>' + clean;
    } catch (e) {
    resultDiv.innerHTML = '<p style="color:#ef4444">Error de conexión. Intenta de nuevo.</p>';
    } finally {
    loadingDiv.style.display = 'none';
    resultDiv.style.display = 'block';
    }
});
}

  // --- Sticky Bar ---
  var stickyBar = document.getElementById('cev-sticky-bar');
  var stickyClose = document.getElementById('cev-sticky-close');
  var stickyShown = false;

  if (stickyBar) {
    window.addEventListener('scroll', function () {
      if (!stickyShown && window.scrollY > 600) {
        stickyBar.classList.add('visible');
        stickyShown = true;
      }
    });
    if (stickyClose) {
      stickyClose.addEventListener('click', function () {
        stickyBar.style.display = 'none';
      });
    }
  }


})();  